"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundBase = void 0;
const protocol_1 = require("@prophouse/protocol");
const gql_1 = require("../../gql");
const utils_1 = require("../../utils");
const chain_base_1 = require("../../chain-base");
const gov_power_1 = require("../../gov-power");
const randombytes_1 = __importDefault(require("randombytes"));
class RoundBase extends chain_base_1.ChainBase {
    // prettier-ignore
    constructor(config) {
        super(config);
        /**
         * EIP712 domain
         */
        this.DOMAIN = {
            name: 'prop-house',
            version: '1',
            chainId: this._evmChainId.toString(),
        };
        this._govPower = config.govPower ?? gov_power_1.GovPowerManager.for(config);
        this._query = config.query ?? gql_1.QueryWrapper.for(config.evmChainId);
        this._relayer = config.customStarknetRelayer || RoundBase.DEFAULT_STARKNET_RELAYERS[this._evmChainId];
    }
    /**
     * Internal helper that returns the current timestamp in seconds
     */
    static get _TIMESTAMP_SECS() {
        return Math.floor(Date.now() / 1000);
    }
    /**
     * The Starknet relayer URL
     */
    get relayer() {
        return this._relayer;
    }
    /**
     * Given the provided params, return the round state
     * @param _params The information required to get the round state
     */
    static getState(_params) {
        throw new Error('Not implemented');
    }
    /**
     * Send a payload to the Starknet relayer
     * @param params The JSON RPC params
     */
    async sendToRelayer(params) {
        const res = await fetch(`${this.relayer}/${this.relayerPath}`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                jsonrpc: '2.0',
                method: 'send',
                params,
                id: null,
            }),
        });
        const json = await res.json();
        return json.result;
    }
    /**
     * Generate the salt that's included in the signed message
     */
    generateSalt() {
        return Number(utils_1.splitUint256.SplitUint256.fromHex(utils_1.bytes.bytesToHex((0, randombytes_1.default)(4))).toHex());
    }
    /**
     * Pick the provided keys from the provided object
     * @param object The object to pick from
     * @param keys The keys to pick
     */
    pick(object, keys) {
        return Object.assign({}, ...keys.map(key => {
            if (object && Object.prototype.hasOwnProperty.call(object, key)) {
                return { [key]: object[key] };
            }
        }));
    }
}
exports.RoundBase = RoundBase;
/**
 * Shared EIP712 types
 */
RoundBase.EIP_712_TYPES = {
    UserStrategy: [
        { name: 'id', type: 'uint256' },
        { name: 'userParams', type: 'uint256[]' },
    ],
    Asset: [
        { name: 'assetId', type: 'uint256' },
        { name: 'amount', type: 'uint256' },
    ],
};
/**
 * Default Starknet relayers
 */
RoundBase.DEFAULT_STARKNET_RELAYERS = {
    [protocol_1.ChainId.EthereumMainnet]: 'https://starknet-relayer-mainnet.onrender.com',
    [protocol_1.ChainId.EthereumGoerli]: 'https://starknet-relayer-v2.onrender.com',
};
